import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';

@Component({
  selector: 'app-aba-reentrega',
  templateUrl: './aba-reentrega.component.html',
  styleUrls: ['./aba-reentrega.component.scss']
})

export class AbaReentregaComponent {
  static Title = "Reentrega";
  static Concluido = (el: FormGroup) => {
    return true;
  }
  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input("PedidoId") pedidoId: number;
  displayedColumns: string[] = ["nrtRelacionada", "tipoPedido"];
  dataSource: any[];
  isLoading: boolean = false;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor( ) {}

  ngOnInit() {
    if (this.pedido) this.carregarReeentregas();
  }

  carregarReeentregas() {
    this.isLoading = true;
    this.dataSource = this.pedido?.reentregas;
    this.isLoading = false;
  }

  refresh() {
    this.isLoading = true;
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

}
